module.exports = __webpack_public_path__ + "static/media/splash.1623d1c7.jpg";